/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Cell } from "react-table";
import { Button, FlexContainer } from "@nordcloud/gnui";
import { ReactComponent as AvatarIcon } from "~/assets/images/avatar.svg";

type Props = {
  onEditHandler: (item: Person) => void;
  setDeleteData: React.Dispatch<
    React.SetStateAction<{
      id: string;
      name: string;
    }>
  >;
  openModal: () => void;
};

type Person = {
  id: string;
  name: string;
  email: string;
};

export const EmployeesListColumns = ({
  onEditHandler,
  setDeleteData,
  openModal,
}: Props) => [
  {
    width: "3%",
    disableSortBy: true,
    accessor: "id",
    Cell: () => <AvatarIcon />,
  },
  {
    Header: "Contact Name",
    accessor: "name",
    disableSortBy: true,
    Cell: ({ row }: Cell<Person>) => <div>{row?.original?.name}</div>,
  },
  {
    Header: "Email",
    accessor: "email",
    disableSortBy: true,
    Cell: ({ row }: Cell<Person>) => <div>{row?.original?.email}</div>,
  },
  {
    Header: "Actions",
    accessor: "actions",
    disableSortBy: true,
    width: "4.5rem",
    Cell: ({ row }: Cell<Person>) => (
      <FlexContainer>
        <Button
          mr="0.5rem"
          size="md"
          severity="low"
          icon="edit"
          data-testid="edit-person"
          onClick={() => {
            onEditHandler({
              id: row?.original?.id,
              name: row?.original?.name,
              email: row?.original?.email,
            });
          }}
        />
        <Button
          size="md"
          severity="low"
          icon="trash"
          onClick={() => {
            openModal();
            setDeleteData({ id: row?.original?.id, name: row?.original?.name });
          }}
        />
      </FlexContainer>
    ),
  },
];
